import { render, staticRenderFns } from "./CustomPagingDraggingList.vue?vue&type=template&id=4b0ed35e&scoped=true"
import script from "./CustomPagingDraggingList.vue?vue&type=script&lang=js"
export * from "./CustomPagingDraggingList.vue?vue&type=script&lang=js"
import style0 from "./CustomPagingDraggingList.vue?vue&type=style&index=0&id=4b0ed35e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0ed35e",
  null
  
)

export default component.exports